import { Controller } from "stimulus";
import Rails from "@rails/ujs";

// Wraps the questionnaire builder when it is opened from a task, adding the
// actions that take the admin back to that task.
export default class extends Controller {
  static targets = ["assignForm"];

  static values = {
    hasAssigned: Boolean,
    replaceTitle: String,
    replaceMessage: String,
    replaceCancel: String,
    replaceAllow: String
  };

  async saveAndReturn(event) {
    event.preventDefault();

    const contentTab = this._contentTabController();

    if (contentTab?.hasFormTarget) {
      const saved = await contentTab.saveCurrentForm();
      if (!saved) return;
    }

    if (this.hasAssignedValue) {
      try {
        await new Promise((resolve, reject) => {
          Rails.confirm(null, this.element, {
            confirmTitle: this.replaceTitleValue,
            confirmMessage: this.replaceMessageValue,
            confirmCancel: this.replaceCancelValue,
            confirmAllow: this.replaceAllowValue
          }, { confirmCallback: resolve, cancelCallback: reject });
        });
      } catch {
        return;
      }
    }

    this.assignFormTarget.requestSubmit();
  }

  _contentTabController() {
    const element = this.element.querySelector('[data-controller~="questionnaires--content-tab"]');

    return element && this.application
      .getControllerForElementAndIdentifier(element, 'questionnaires--content-tab');
  }
}
